export function formatPrice(price: number) {
    return price.toLocaleString('fa-IR') + " تومان";
}